import { ScrollTop } from "@/components/commons/ScrollTop";
import { Box } from "@mui/material";
import { FC } from "react";
import { Outlet } from "react-router-dom";

export const LoginLayout: FC = () => {
  return (
    <Box width="100%" height={"100vh"} display="flex" justifyContent="center" pt={13} bgcolor="#F8F9F9">
      <ScrollTop />
      <Outlet />
    </Box>
  );
};
